@if (neskoServiceVerfuegbar) {
  <div class="externe-daten">
    <cap-nesko-amtliche-bewertung [awDetailEntry]="neskoEntry?.amtlicherWert" [hasRight]="hasRightAmtlicherWert">
    </cap-nesko-amtliche-bewertung>
    <cap-objekte
      [hasRight]="hasRightObjekte"
      [isAmtlicherWertVerteilt]="neskoEntry?.amtlicherWert?.isAmtlicherWertVerteilt"
      [objekte]="neskoEntry?.objekte">
    </cap-objekte>
    <cap-rubrik [isClosable]="false" [isOpen]="true" id="rubrik-grundstueckbeschreibung">
      <ng-container title>
        <h2 class="mb-0">{{ "neskoab.EigentumVerteiler" | translate }}</h2>
      </ng-container>
      @if ((neskoEntry?.verteiler && neskoEntry?.verteiler.length != 0) || neskoEntry?.eigentum) {
      } @else {
        <div class="mb-2">
          <span>{{ "gemaessAmtlicherBewertung" | translate }}</span>
        </div>
      }
      @if (neskoEntry?.verteiler && neskoEntry?.verteiler.length > 0) {
        <cap-neskoab-grundstueck-eigentum
          [eigentum]="neskoEntry?.verteiler"
          [eigentumsform]="neskoEntry?.eigentum?.eigentumForm"
          [hasRight]="hasRightVerteiler">
        </cap-neskoab-grundstueck-eigentum>
      } @else {
        @if (neskoEntry?.eigentum) {
          <cap-neskoab-personen-eigentum [eigentum]="[neskoEntry?.eigentum]" [hasRight]="hasRightEigentum"></cap-neskoab-personen-eigentum>
        }
      }
    </cap-rubrik>
    <cap-neskoab-nutzniesser [hasRight]="hasRightNutzniessung" [nutzniesser]="neskoEntry?.nutzniesser"></cap-neskoab-nutzniesser>
  </div>
} @else {
  <div class="mt-3">
    <cap-bsg-alert [type]="'warning'">
      {{ "neskoab.nichtVerfuegbar" | translate }}
    </cap-bsg-alert>
  </div>
}
